document.addEventListener('alpine:init', () => {
    Alpine.data('xFiltersAndSortby', (sectionId) => ({
      t: '',
      loading: false,
      isDesktop: false,
      cachedResults: [],
      searchParamsPrev: window.location.search.slice(1),
      searchParamsInitial: window.location.search.slice(1),
      init() {
        if (window.innerWidth > 767) this.isDesktop = true;
        this._setListeners();
      },
      _setListeners() {
        const onHistoryChange = (event) => {
          const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
          if (searchParams === this.searchParamsPrev) return;
          this._renderPage(searchParams, false);
        }
        window.addEventListener('popstate', onHistoryChange);
      },
      removeFilter(url) {
        this._reloadFilter(url);
      },
      renderPagination() {
        var formData = {
          'attributes': {
            'collection-pagination': this.$el.value             
          }
        }; 
        fetch(Shopify.routes.root+'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(formData)
        }).then(() => {
            this.cachedResults = [];
            const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
            this._renderPage(searchParams);
          }); 
      },
      onSubmit(wait = 500) {
        clearTimeout(this.t);

        const func = () => {
          const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
          this._renderPage(searchParams);
          if(this.isDesktop) document.getElementById('FormSelectFilter').blur();
        }
        
        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      _reloadFilter(url) {
        const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
        this._renderPage(searchParams);
      },
      _createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
      },
      _updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      },
      _renderPage(searchParams, updateURLHash = true) {
        this.searchParamsPrev = searchParams;
        this.loading = true;
        
        if (this.cachedResults[searchParams]) {
          this._renderResults(this.cachedResults[searchParams]);
          return;
        }

        const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
        fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = responseText;
            this.cachedResults[searchParams] = html;
            this._renderResults(html);
          });

        if (updateURLHash) this._updateURLHash(searchParams);
      },
      _renderResults(html) {
        this._renderFilters(html);
        this._renderProductGridContainer(html);
        this._renderProductCount(html);
        this.loading = false;
      },
      _renderFilters(html) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements =
          parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
        const matchesIndex = (element) => {
          const jsFilter = !this.$el.classList.contains('facet-reset') ? this.$el.closest('.js-filter') : undefined;
          return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
          document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        this._renderActiveFacets(parsedHTML);
        this._renderAdditionalElements(parsedHTML);

        if (countsToRender) this._renderCounts(countsToRender, this.$el .closest('.js-filter'));
      },
      _renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
      },
      _renderProductCount(html) {
        const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
        if (productCountEl) {
          const count = productCountEl.innerHTML;
          const container = document.getElementById('ProductCount');
          const containerDrawer = document.getElementById('ProductCountDrawer');
          container.innerHTML = count;
          containerDrawer.innerHTML = count;
          container.classList.remove('loading');
        }
      },
      _renderActiveFacets(html) {
        document.getElementById('active-filter-tag').innerHTML = html.getElementById('active-filter-tag').innerHTML;
      },
      _renderAdditionalElements(html) {
        const container = document.getElementById('ProductPerPage');
        if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
      },
      _renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');
    
        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');
    
        if (sourceElement && targetElement) {
          target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }
    
        if (targetElementAccessibility && sourceElementAccessibility) {
          target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
      },
      _filterFocus() {
        Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
      },
      _filterRemoveFocus() {
        const activeElement = document.getElementById('btn-filter');
        Alpine.store('xFocusElement').removeTrapFocus(activeElement);
      }
    }));
  });